

















import mixins from 'vue-typed-mixins';
import { AutomatedEmailParams } from '@/utils/EmailUtils';
import RoleUtils, { Role } from '@/utils/RoleUtils';
import { DataTableHeader } from 'vuetify';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => AutomatedEmailParams,
    },
  },

  computed: {
    headers(): DataTableHeader<Role>[] {
      return [
        { text: this.$i18n.tc('model.common.name'), value: 'name' },
        { text: this.$i18n.tc('model.common.type'), value: 'type' },
      ];
    },
  },

  data(): {
    roles?: Role[];
  } {
    return {
      roles: undefined,
    };
  },

  async mounted() {
    try {
      this.$emit('validate', true); // always valid
      this.roles = await RoleUtils.api.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
});
